var map = {
	"./dc-arrow.jpg": 36,
	"./dc-batman.jpg": 37,
	"./dc-black.jpg": 38,
	"./dc-blue.jpg": 39,
	"./dc-flash.jpg": 40,
	"./dc-green.jpg": 41,
	"./dc-martian.jpg": 42,
	"./dc-robin.jpg": 43,
	"./dc-superman.jpg": 44,
	"./dc-wonder.jpg": 45,
	"./marvel-captain.jpg": 46,
	"./marvel-cyclops.jpg": 47,
	"./marvel-daredevil.jpg": 48,
	"./marvel-hawkeye.jpg": 49,
	"./marvel-hulk.jpg": 50,
	"./marvel-iron.jpg": 51,
	"./marvel-silver.jpg": 52,
	"./marvel-spider.jpg": 53,
	"./marvel-thor.jpg": 54,
	"./marvel-wolverine.jpg": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;